// extracted by mini-css-extract-plugin
export var component = "PageBreadcrumbs-module--component--PN97F";
export var inner = "PageBreadcrumbs-module--inner--GQq78";